(function () {
  function init(root) {
    var grid = root.querySelector('[data-recipe-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-recipe-card]'));
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-chip]'));
    var search = root.querySelector('[data-recipe-search]');
    var sortSel = root.querySelector('[data-recipe-sort]');
    var countEl = root.querySelector('[data-recipe-count]');
    var emptyEl = root.querySelector('[data-recipe-empty]');
    var clearBtn = root.querySelector('[data-recipe-clear]');
    var allChip = root.querySelector('[data-recipe-all]');
    var searchWrap = root.querySelector('[data-search-wrap]');
    var searchToggle = root.querySelector('[data-search-toggle]');
    var searchClear = root.querySelector('[data-search-clear]');

    // active = { type: Set(values) }
    var active = {};

    // All cards stay in the pool (filters/search cover everything), but only
    // revealLimit matches are shown; scrolling near the bottom reveals more.
    var REVEAL_STEP = 24;
    var revealLimit = REVEAL_STEP;
    function resetReveal() { revealLimit = REVEAL_STEP; }

    var sentinel = document.createElement('div');
    sentinel.className = 'recipe-grid__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealLimit += REVEAL_STEP;
            apply();
          }
        });
      }, { rootMargin: '600px 0px' }).observe(sentinel);
    } else {
      revealLimit = Infinity; // no observer support: show everything, like before
    }

    function tokens(card, type) {
      return (card.getAttribute('data-' + type) || '').split(/\s+/).filter(Boolean);
    }

    function matches(card) {
      // AND across types, OR within a type.
      for (var type in active) {
        if (!active[type] || active[type].size === 0) continue;
        var vals = tokens(card, type);
        var hit = false;
        active[type].forEach(function (v) { if (vals.indexOf(v) !== -1) hit = true; });
        if (!hit) return false;
      }
      if (search && search.value.trim()) {
        var q = search.value.trim().toLowerCase();
        if ((card.getAttribute('data-title') || '').indexOf(q) === -1) return false;
      }
      return true;
    }

    function apply() {
      var matched = 0;
      cards.forEach(function (c) {
        if (matches(c)) {
          matched++;
          c.hidden = matched > revealLimit;
        } else {
          c.hidden = true;
        }
      });
      var visible = Math.min(matched, revealLimit);
      if (sentinel) sentinel.hidden = matched <= revealLimit;
      var query = search ? search.value.trim() : '';
      if (countEl) {
        // Contextual count, like the design: "Showing 3 smoothie recipes for "banana""
        var pressed = chips.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; });
        var ctx = pressed.length === 1 ? ' ' + pressed[0].textContent.trim().toLowerCase() : '';
        var shown = matched > visible ? visible + ' of ' + matched : String(visible);
        var text = 'Showing ' + shown + ctx + ' recipe' + (matched === 1 ? '' : 's');
        if (query) text += ' for “' + query + '”';
        countEl.textContent = text;
      }
      if (emptyEl) {
        emptyEl.hidden = matched !== 0;
        if (matched === 0) {
          var title = emptyEl.querySelector('.recipe-empty__title');
          var sub = emptyEl.querySelector('.recipe-empty__sub');
          if (title) title.textContent = query ? 'No recipes match “' + query + '”.' : 'No recipes for that combination yet.';
          if (sub) sub.textContent = query ? 'Try another search or clear it.' : 'Try a different filter.';
        }
      }
      var anyActive = Object.keys(active).some(function (t) { return active[t] && active[t].size; }) || !!query;
      if (clearBtn) clearBtn.hidden = !anyActive;
      if (allChip) allChip.setAttribute('aria-pressed', anyActive ? 'false' : 'true');
      if (searchClear) searchClear.hidden = !query;
    }

    function sort(mode) {
      cards = cards.slice().sort(function (a, b) {
        var da = parseInt(a.getAttribute('data-date'), 10) || 0;
        var db = parseInt(b.getAttribute('data-date'), 10) || 0;
        return mode === 'oldest' ? da - db : db - da;
      });
      cards.forEach(function (c) { grid.appendChild(c); });
    }

    function bindChip(chip) {
      chip.addEventListener('click', function () {
        var type = chip.getAttribute('data-filter-type');
        var val = chip.getAttribute('data-filter-value');
        active[type] = active[type] || new Set();
        if (active[type].has(val)) { active[type].delete(val); chip.setAttribute('aria-pressed', 'false'); }
        else { active[type].add(val); chip.setAttribute('aria-pressed', 'true'); }
        resetReveal();
        apply();
      });
    }
    chips.forEach(bindChip);

    // Deep links: /blogs/recipes?category=smoothie (the detail breadcrumb) preselects
    // the matching chip. Re-run after hydration in case the chip arrives late.
    function preselectFromURL() {
      var params = new URLSearchParams(window.location.search);
      ['category', 'product'].forEach(function (type) {
        var want = params.get(type);
        if (!want) return;
        chips.some(function (chip) {
          if (chip.getAttribute('data-filter-type') !== type) return false;
          if (chip.getAttribute('data-filter-value') !== want) return false;
          if (chip.getAttribute('aria-pressed') !== 'true') chip.click();
          return true;
        });
      });
    }
    if (search) search.addEventListener('input', function () { resetReveal(); apply(); });
    if (sortSel) sortSel.addEventListener('change', function () { resetReveal(); sort(sortSel.value); apply(); });
    function clearAll() {
      active = {}; if (search) search.value = '';
      chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
      if (sortSel) { sortSel.value = 'newest'; sort('newest'); }
      resetReveal();
      apply();
      closeSearch();
    }
    if (clearBtn) clearBtn.addEventListener('click', clearAll);
    if (allChip) allChip.addEventListener('click', clearAll);

    // Collapsible search: icon expands into the input; collapses when empty.
    function openSearch() {
      if (!searchWrap) return;
      searchWrap.classList.add('is-open');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () { if (search) search.focus(); }, 190);
    }
    function closeSearch() {
      if (!searchWrap || (search && search.value.trim())) return;
      searchWrap.classList.remove('is-open');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    }
    if (searchToggle) searchToggle.addEventListener('click', openSearch);
    if (searchClear) searchClear.addEventListener('click', function () {
      search.value = '';
      resetReveal();
      apply();
      search.focus();
    });
    if (search) search.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { search.value = ''; resetReveal(); apply(); search.blur(); closeSearch(); }
    });
    if (searchWrap) document.addEventListener('mousedown', function (e) {
      if (searchWrap.classList.contains('is-open') && !searchWrap.contains(e.target)) closeSearch();
    });

    apply();
    preselectFromURL();

    // A token that only appears on hydrated pages (2+) has no server-rendered chip —
    // derive one from the card's data attributes so those recipes stay filterable.
    function titlecase(token) {
      return token.replace(/-/g, ' ').replace(/\b\w/g, function (ch) { return ch.toUpperCase(); });
    }
    function ensureChips() {
      var known = {};
      chips.forEach(function (c) {
        known[c.getAttribute('data-filter-type') + ':' + c.getAttribute('data-filter-value')] = true;
      });
      var axisWrap = root.querySelector('.recipe-chips');
      cards.forEach(function (card) {
        [{ type: 'product', attr: 'product' }, { type: 'category', attr: 'category' }].forEach(function (def) {
          tokens(card, def.attr).forEach(function (val) {
            var key = def.type + ':' + val;
            if (known[key]) return;
            known[key] = true;
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'recipe-chip';
            chip.setAttribute('data-chip', '');
            chip.setAttribute('data-filter-type', def.type);
            chip.setAttribute('data-filter-value', val);
            chip.setAttribute('aria-pressed', 'false');
            chip.textContent = titlecase(val);
            if (def.type === 'product' && searchWrap && searchWrap.parentNode) {
              searchWrap.parentNode.insertBefore(chip, searchWrap);
            } else if (axisWrap) {
              axisWrap.appendChild(chip);
            } else {
              return; // no axis row rendered server-side; skip rather than build one
            }
            bindChip(chip);
            chips.push(chip);
          });
        });
      });
    }

    // Background hydration: the grid is paginated server-side (Shopify caps un-paginated
    // loops at 50 articles), so fetch the remaining pages quietly and merge their cards
    // into the filter pool. Filters/search then cover the whole blog, not just page 1.
    var totalPages = parseInt(grid.getAttribute('data-total-pages'), 10) || 1;
    if (totalPages > 1 && window.fetch && window.DOMParser) {
      var pageFetches = [];
      for (var p = 2; p <= totalPages; p++) (function (pageNum) {
        var u = new URL(window.location.href);
        u.searchParams.set('page', pageNum);
        pageFetches.push(
          fetch(u.toString())
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              return Array.prototype.slice.call(doc.querySelectorAll('[data-recipe-grid] [data-recipe-card]'));
            })
        );
      })(p);
      Promise.all(pageFetches).then(function (pages) {
        pages.forEach(function (nodes) {
          nodes.forEach(function (n) {
            var node = document.importNode(n, true);
            grid.appendChild(node);
            cards.push(node);
          });
        });
        sort(sortSel ? sortSel.value : 'newest');
        ensureChips();
        apply();
        preselectFromURL();
      }).catch(function () { /* leave page-1 cards working if a fetch fails */ });
    }
  }

  function boot() {
    document.querySelectorAll('[data-recipe-landing]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
